import React, {useRef, useState} from "react";
import axios from "axios";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import alertify from "alertifyjs";
import {API_URL} from "../constants.js";

import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

export function MachineCreate(props) {
    const {t} = useTranslation();
    const name = useRef();
    const short_code = useRef();
    const model = useRef();
    const [disabled, setDisabled] = useState(0);
    const [iconDisabled, setIconDisabled] = useState(1);

    const createMachineHandler = (e) => {
        e.preventDefault();
        if (!name.current.value.trim()) {
            alertify.error(t("Machine name is required"));
            return;
        }
        setDisabled(1);
        setIconDisabled(0);
        axios.post(API_URL + "machine/create", {
            name: name.current.value,
            short_code: short_code.current.value,
            model: model.current.value,
        }).then((response) => {
            setDisabled(0);
            setIconDisabled(1);
            if (response.data.status) {
                alertify.success(response.data.message);
                props.history.push("/machine/list");
            } else {
                alertify.error(response.data.message);
                return null;
            }
        }).catch((error) => {
            setDisabled(0);
            setIconDisabled(1);
            alertify.error("Something went wrong. Try again!");
        });
    };

    return (
        <>
            <Row>
                <Col md={12}>
                    <Card>
                        <CardHeader title={t("Create New Machine")}>
                            <CardHeaderToolbar>
                                <Link to="/machine/list" className="btn btn-primary btn-sm mx-3">
                                    {t("Machine List")}
                                </Link>
                            </CardHeaderToolbar>
                        </CardHeader>
                        <CardBody>
                            <div className="mt-3">
                                <Form onSubmit={createMachineHandler}>
                                    <Form.Row>
                                        <Form.Group as={Col} md={4}>
                                            <Form.Label>{t("Name")} <span className="text-danger">*</span></Form.Label>
                                            <Form.Control ref={name} placeholder={t("Enter Machine Name")} required/>
                                        </Form.Group>
                                        <Form.Group as={Col} md={4}>
                                            <Form.Label>{t("Short Code")}</Form.Label>
                                            <Form.Control ref={short_code} placeholder={t("Enter Short Code")}/>
                                        </Form.Group>
                                        <Form.Group as={Col} md={4}>
                                            <Form.Label>{t("Model")}</Form.Label>
                                            <Form.Control ref={model} placeholder={t("Enter Model")}/>
                                        </Form.Group>
                                    </Form.Row>
                                    <Button variant="primary" className="float-right" type="submit" disabled={disabled}>
                                        {t("Save Machine")}
                                        <span dangerouslySetInnerHTML={{__html: disabled ? ` <i class='fas fa-spinner fa-spin'></i>` : ``}}/>
                                    </Button>
                                </Form>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </>
    );
}
